import { render, staticRenderFns } from "./LearningUnitPartDescriptionCard.vue?vue&type=template&id=1b0b306c&"
import script from "./LearningUnitPartDescriptionCard.vue?vue&type=script&lang=js&"
export * from "./LearningUnitPartDescriptionCard.vue?vue&type=script&lang=js&"
import style0 from "./LearningUnitPartDescriptionCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports